import React from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'

const Acknowledgement = (props) => {
  return (
    <div>
    <Modal isOpen={props.bootstrap_modal_open}>
        <ModalHeader style={{fontWeight:'bold', color:'darkblue'}}>Acknowledgement Notification</ModalHeader>
        <ModalBody style={{fontStyle:"italic", color:'grey'}}>1. This application is developed and owned by Romeo Joseph S <br/>
            2. Currently we display the stock data records until yesterday. We are working to bring live data stock analysis to your lap as early as possible. <br/>
            3. You have a referral code, you can provide this referral code to 3 new users and earn credits for up to Rs.300/- added onto your wallet in this app. <br/>
            4. We are handling the stock splits manually, in case if a company splits the stocks, we manually split it. But if you see that a price wasn't split correctly or is missed, please drop a note to romeo7Aug1992@gmail.com, we'll do the necessary changes and update you at the earliest. <br/>
            5. If you think that this app can be further developed, please email us your valuable insights to romeo7Aug1992@gmail.com, we'll look into it and if feasible, we'll definitely do the necessary modifications/introduce enhancements. <br/>
        </ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={props.toggle_bootstrap_modal}>I Acknowledge</Button>
        </ModalFooter>
    </Modal>
    </div>
  )
}

export default Acknowledgement
